import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Contextos
import { useToast } from '../../contexts/ToastContext';

// Estilos
import styles from './loginpage.module.css';

// API
import { useUsuarioService } from '../../services/usuarioServices';

function RecuperarSenhaUsuarioPage() {
    const { showToast } = useToast();
    const navigate = useNavigate();

    const { gerarCodigoRecuperacaoUsuario, obterUsuarioPorNome } = useUsuarioService();

    const [telefone, setTelefone] = useState('');
    const [email, setEmail] = useState('');
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');
    const [usuario, setUsuario] = useState(null);

    // 📱 Máscara de telefone
    const aplicarMascaraTelefone = (valor) => {
        const numeros = valor.replace(/\D/g, '').slice(0, 11);
        const parte1 = numeros.slice(0, 2);
        const parte2 = numeros.slice(2, 7);
        const parte3 = numeros.slice(7, 11);

        if (numeros.length <= 2) return `(${parte1}`;
        if (numeros.length <= 7) return `(${parte1}) ${parte2}`;
        return `(${parte1}) ${parte2}-${parte3}`;
    };

    const handleTelefoneChange = (e) => {
        const valor = e.target.value;
        setTelefone(aplicarMascaraTelefone(valor));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setCarregando(true);
        setErro('');
        setUsuario(null);

        const telefoneLimpo = telefone.replace(/\D/g, '');

        if (telefoneLimpo.length !== 11) {
            showToast('O telefone deve conter 11 dígitos.', 3000, 'error');
            setCarregando(false);
            return;
        }

        if (!email.includes('@') || !email.includes('.')) {
            showToast('Digite um e-mail válido.', 3000, 'error');
            setCarregando(false);
            return;
        }

        try {
            // Apenas para debug ou validação opcional
            const resposta = await gerarCodigoRecuperacaoUsuario({
                telefone: telefoneLimpo,
                email: email.trim().toLowerCase()
            });

            if (resposta.success) {
                showToast('Código e link enviados para seu WhatsApp!', 3000, 'success');
            } else {
                setErro(resposta.message || 'Falha ao gerar código.');
                showToast(resposta.message || 'Falha ao gerar código.', 3000, 'error');
            }

        } catch (error) {
            console.error(error);
            setErro('Erro na solicitação.');
            showToast('Erro na solicitação.', 3000, 'error');
        }

        setCarregando(false);
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Recuperar Senha (Administrador)</h2>

            <form onSubmit={handleSubmit} className={styles.form}>

                <p>Informe seu telefone e e-mail cadastrados. Enviaremos um código para seu WhatsApp.</p>

                <input
                    type="text"
                    placeholder="(11) 91234-5678"
                    value={telefone}
                    onChange={handleTelefoneChange}
                    className={styles.input}
                    required
                />

                <input
                    type="email"
                    placeholder="seuemail@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.input}
                    required
                />

                <button type="submit" className={styles.button} disabled={carregando}>
                    {carregando ? 'Enviando código...' : 'Enviar Código'}
                </button>

                {erro && <p className={styles.error}>{erro}</p>}
            </form>
        </div>
    );
}

export default RecuperarSenhaUsuarioPage;